import { gql } from '@apollo/client'

export const REQUEST_COST_COVERAGE = gql`
  mutation requestCostCoverage(
    $id: ID!
    $attributes: CostCoverageInput!
    $attachmentBlobIds: [String!]
  ) {
    requestCostCoverage(id: $id, attributes: $attributes, attachmentBlobIds: $attachmentBlobIds)
  }
`
